export const CHAT_PAGE_SIZE = 50;

export const CHAT_STARTED_TYPE = 'ai_chat_started';
export const CHAT_RETRIED_TYPE = 'ai_chat_retried';
export const CHAT_FAILED_TYPE = 'ai_chat_failed';
export const CHAT_COMPLETED_TYPE = 'ai_chat_completed';
export const CHAT_RECEIVE_MESSAGE_TYPE = 'receive_ai_message';
export const CHAT_ACTION_TYPE = 'ai_chat_action';
export const CHAT_SEND_MESSAGE_TYPE = 'send_ai_message';
export const CHAT_RESPONSE_DELTA_TYPE = 'response.output_text.delta';
export const CHAT_RESPONSE_COMPLETED_TYPE = 'response.completed';

export const CHAT_QUERY_PARAM = 'chat';
export const CHAT_QUERY_OPEN_VALUE = 'open';

export const INSTRUCTOR_HUGO_CHAT_TYPE = 'instructor_hugo';
export const NEW_THREAD_VALUE = 'new';
export const THREAD_SUMMARY_LIMIT = 20;

export const EmptyAssistantDraft = '';

export const ChatStartTimeoutMs = 45_000;
export const ChatCompletionTimeoutMs = 120_000;

export const ChatMergeMode = {
    PREPEND: 'prepend',
    REPLACE: 'replace',
};

export const ChatRole = {
    USER: 'user',
    ASSISTANT: 'assistant',
    SYSTEM: 'system',
};

export const ChatLayout = {
    DEFAULT: 'default',
    FULLSCREEN: 'fullscreen',
};

export const AssistantMessageStatusType = {
    COMPLETE: 'complete',
    RUNNING: 'running',
};

export const AssistantMessageStatusReason = {
    STOP: 'stop',
};

export const ChatSystemType = {
    SUBMISSION_CREATED: 'submission_created',
};

export const ChatErrorKind = {
    DISCONNECTED: 'disconnected',
    GENERATION: 'generation',
    UNSUPPORTED_REQUEST: 'unsupported_request',
};

export const ChatErrorAction = {
    REFRESH: 'refresh',
    REGENERATE: 'regenerate',
};

export const ChatEventType = {
    LEGACY_DELTA: 'chat_delta',
    LEGACY_FINAL: 'chat_final',
};

export const ChatRequestLifecycleEvent = {
    ASSISTANT_MESSAGE_CREATED: 'assistant_message_created',
    CHAT_BOUND: 'chat_bound',
    CONTINUATION_STARTED: 'continuation_started',
    REQUEST_STARTED: 'request_started',
    REQUEST_FAILED: 'request_failed',
    RUNTIME_STATE_CHANGED: 'runtime_state_changed',
    USER_MESSAGE_CREATED: 'user_message_created',
};

export const ChatPromptInputType = {
    BINARY: 'binary',
    CONTINUE: 'continue',
};

export const ChatPromptActionId = {
    ACCEPT: 'accept',
    REJECT: 'reject',
    CONTINUE: 'continue',
};

export const ChatLoadingRequestType = {
    STANDARD: 'standard',
    CONTINUATION: 'continuation',
};

export const AssistantInteractionStatus = {
    PENDING: 'pending',
    PROCESSING: 'processing',
    SELECTED: 'selected',
    COMPLETED: 'completed',
    FAILED: 'failed',
};

export const UnsupportedRequestPatterns = [
    "couldn't help with your request",
    'try asking another question about your feedback',
    'bad faith',
    'not related to your feedback',
    'not related to the feedback',
    'policy',
    'unsafe',
];
